// extracted by mini-css-extract-plugin
export var actualiteCategorie = "actualites-module--actualite-categorie--e0269";
export var actualiteContainer = "actualites-module--actualiteContainer--9c3df";
export var actualiteContainerFirst = "actualites-module--actualiteContainerFirst--b470f";
export var actualiteInfos = "actualites-module--actualite-infos--24e6b";
export var actualiteResume = "actualites-module--actualite-resume--15ebc";
export var actualiteTitle = "actualites-module--actualite-title--05e8d";
export var actualitesContainer = "actualites-module--actualites-container--d5812";
export var actualitesDescription = "actualites-module--actualites-description--5fda0";
export var autresActualites = "actualites-module--autres-actualites--0c941";
export var editButtonFirstActu = "actualites-module--edit-button-first-actu--2cd1e";
export var editButtonTitle = "actualites-module--edit-button-title--bd411";
export var listActualitesContainer = "actualites-module--list-actualites-container--65fbf";
export var listActualitesTitle = "actualites-module--list-actualites-title--e1f2e";